module.exports = __webpack_public_path__ + "img/banne02_logo.f4af49b2.png";